.cardHeader {
	@apply -yst-mt-6 -yst-mx-6 yst-p-6;
}

.cardContent {
	@apply yst-mt-0 yst-space-y-6 #{!important};
}

section.section {
	@apply yst-space-y-4;
}

// Webinar banner + registration button, side by side in a tinted, bordered container.
// The button keeps its natural height and is centered against the taller banner.
div.webinar {
	@apply yst-flex yst-items-center yst-gap-4 yst-rounded-lg yst-border yst-border-primary-200 yst-bg-primary-50;
}

.webinarImage {
	@apply yst-rounded-md yst-object-cover;
	// Narrower than the button pair so the banner doesn't dominate.
	flex: 2 1 0%;
	min-width: 0;
	height: 7rem;
}

.registerButton {
	@apply yst-justify-center yst-gap-2 yst-whitespace-nowrap yst-me-3;
	flex: 2 1 0%;
	min-width: 8rem;
	// Beat the ui-library Button defaults: larger text to match the design.
	font-size: 1rem !important;
	font-weight: 600 !important;
}

// A blog post, styled as a bordered row with a "Read more" call to action.
ul.blogList {
	@apply yst-space-y-3;
}

li.blogItem {
	@apply yst-flex yst-flex-wrap yst-items-center yst-gap-4 yst-rounded-lg yst-border yst-border-slate-200 yst-p-4;
}

.blogItemImage,
.blogItemImagePlaceholder {
	@apply yst-flex-none yst-rounded-md yst-object-cover;
	width: 3.5rem;
	height: 3.5rem;
}

.blogItemImagePlaceholder {
	@apply yst-bg-slate-100;
}

.blogItemContent {
	@apply yst-space-y-1;
	flex: 1 1 12rem;
}

.blogItemTitle {
	@apply yst-font-semibold yst-text-slate-800;
}

.blogItemDescription {
	@apply yst-text-sm yst-text-slate-600;
}

.readMoreButton {
	@apply yst-flex-none yst-justify-center yst-gap-1 yst-whitespace-nowrap;
}

.buttonIcon {
	@apply yst-inline-block yst-w-3 yst-h-3;
}

// Footer "Visit the SEO blog" link, right-aligned with a trailing arrow.
.cardFooter {
	@apply yst-flex yst-justify-end;
	border: 0;
	padding: 0 !important;
}

// Both the footer link and the inline "All webinars" fallback link are magenta with
// no underline. `!important` is needed to beat the app's global anchor styling.
.footerLink,
.inlineLink {
	@apply yst-inline-flex yst-items-center yst-gap-1 yst-font-medium yst-no-underline yst-text-primary-500 hover:yst-text-primary-700 #{!important};
}

.footerArrow {
	@apply yst-inline-block yst-w-4 yst-h-4;
}
